import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { updateShipments } from '../../redux/actions/purchaseOrders';

const UpdateShipmentModal = ({ payload, showUpdateShipmentModal, setShowUpdateShipmentModal, shipment, sendUpdateShipments, shipments, setShipments, purchaseOrderId }) => {

  const [companyName, setCompanyName] = useState(shipment.company_name);
  const [tracking, setTracking] = useState(shipment.tracking);
  const [taxes, setTaxes] = useState(shipment.taxes);
  const [other, setOther] = useState(shipment.other);

  const shipmentJson = () => {
    return {
      id: crypto.randomUUID(),
      company_name: companyName,
      tracking: tracking,
      taxes: taxes,
      other: other
    }
  }

  const changeCompany = (event) => {
    let value = event.target.value;

    if (value) {
      event.target.parentElement.classList.add("field--filled");
    } else {
      event.target.parentElement.classList.remove("field--filled");
    }

    setCompanyName(value);
  }

  const changeTracking = (event) => {
    let value = event.target.value;

    if (value) {
      event.target.parentElement.classList.add("field--filled");
    } else {
      event.target.parentElement.classList.remove("field--filled");
    }

    setTracking(value);
  }

  const changeTaxes = (event) => {
    let value = event.target.value;

    if (value) {
      event.target.parentElement.classList.add("field--filled");
    } else {
      event.target.parentElement.classList.remove("field--filled");
    }

    setTaxes(value);
  }

  const changeOther = (event) => {
    let value = event.target.value;

    if (value) {
      event.target.parentElement.classList.add("field--filled");
    } else {
      event.target.parentElement.classList.remove("field--filled");
    }

    setOther(value);
  }


  const update = () => {
    let newShipments = [...shipments];
    let updatedShipment = shipmentJson();
    let toUpdateIndex = newShipments.findIndex((ship) => ship.id === shipment.id);

    newShipments[toUpdateIndex] = updatedShipment;

    sendUpdateShipments(payload, purchaseOrderId, newShipments);
    setShipments(newShipments);
    setShowUpdateShipmentModal(false);
  }

  const focus = (event) => {
    event.target.parentElement.classList.add("field--focus");
  }

  const blur = (event) => {
    event.target.parentElement.classList.remove("field--focus");
  }

  return(
    <div className="main-overlay">
      <div style={{ top: `${window.innerHeight/2}px` }} className="main-popup popup-center-always main-popup_center main-popup--thin-padding main-popup_animation">
        <div className="main-popup__container">
          <div className="main-popup__close" onClick={() => setShowUpdateShipmentModal(false)}>
            <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M1.7929 1.7929c.3905-.3905 1.0237-.3905 1.4142 0L9 7.5858l5.7929-5.793c.3905-.3904 1.0237-.3904 1.4142 0 .3905.3906.3905 1.0238 0 1.4143L10.4142 9l5.7929 5.7929c.3905.3905.3905 1.0237 0 1.4142-.3905.3905-1.0237.3905-1.4142 0L9 10.4142l-5.7929 5.7929c-.3905.3905-1.0237.3905-1.4142 0-.3905-.3905-.3905-1.0237 0-1.4142L7.5858 9l-5.793-5.7929c-.3904-.3905-.3904-1.0237 0-1.4142z">
              </path>
            </svg>
          </div>
          <div className="main-popup__subcontainer">
            
            <h3>Update Shipment</h3>

            <div className="fieldset">

              <div className="field field--medium field--filled">
                <span className="fieldset__svg-icon"></span>
                <label className="field__label">Shipping Company</label>
                <input type="text" value={companyName} onFocus={focus} onBlur={blur} onChange={(e) => changeCompany(e)} className="field__input" tabindex="4" maxlength="64" />
                <div className="field__placeholder">Shipping Company</div>
              </div>

              <div className="field field--medium field--filled">
                <span className="fieldset__svg-icon"></span>
                <label className="field__label">Tracking #</label>
                <input type="text" value={tracking} onFocus={focus} onBlur={blur} onChange={(e) => changeTracking(e)} className="field__input" tabindex="4" maxlength="64" />
                <div className="field__placeholder">Tracking #</div>
              </div>

              <div className="field field--medium field--filled">
                <span className="fieldset__svg-icon"></span>
                <label className="field__label">Taxes/Duties</label>
                <input type="number" value={taxes} onFocus={focus} onBlur={blur} onChange={(e) => changeTaxes(e)} className="field__input" tabindex="4" maxlength="64" />
                <div className="field__placeholder">Taxes/Duties</div>
              </div>

              <div className="field field--medium field--filled">
                <span className="fieldset__svg-icon"></span>
                <label className="field__label">Other</label>
                <input type="text" value={other} onFocus={focus} onBlur={blur} onChange={(e) => changeOther(e)} className="field__input" tabindex="4" maxlength="64" />
                <div className="field__placeholder">Other</div>
              </div>
              
            </div>

            <button className="bottom-5 btn btn-primary btn-medium" onClick={() => update()}>Update Shipment</button>
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
});

const mapDispatchToProps = (dispatch) => ({
  sendUpdateShipments: (payload, purchaseOrderId, shipments) => dispatch(updateShipments(payload, purchaseOrderId, shipments)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UpdateShipmentModal);
